import axios from "utils/axios";

export const getShiftScheduleSwap = (id) => {
  return axios.get(`/hr/shiftScheduleSwaps/${id}`);
};
